"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var react_1 = __importDefault(require("react"));
var rebass_1 = require("rebass");
var tema_1 = require("../../tema");
var Container = function (_a) {
  var sx = _a.sx,
    props = __rest(_a, ["sx"]);
  return react_1.default.createElement(rebass_1.Box, __assign({
    sx: __assign({
      "--PhoneInputInternationalIconPhone-opacity": 0.8,
      "--PhoneInputInternationalIconGlobe-opacity": 0.65,
      "--PhoneInputCountrySelectArrow-width": "0.3em",
      "--PhoneInputCountrySelectArrow-marginLeft": "0.35em",
      "--PhoneInputCountrySelectArrow-borderWidth": "1px",
      "--PhoneInputCountrySelectArrow-opacity": 0.45,
      "--PhoneInputCountrySelectArrow-color": "inherit",
      "--PhoneInputCountrySelectArrow-color--focus": "var(--PhoneInput-color--focus)",
      "--PhoneInputCountrySelectArrow-transform": "rotate(45deg)",
      "--PhoneInputCountryFlag-aspectRatio": 1.5,
      "--PhoneInputCountryFlag-height": "1em",
      "--PhoneInputCountryFlag-borderWidth": "1px",
      "--PhoneInputCountryFlag-borderColor": "rgba(0,0,0,0.5)",
      "--PhoneInputCountryFlag-borderColor--focus": "var(--PhoneInput-color--focus)",
      "--PhoneInputCountryFlag-backgroundColor--loading": "rgba(0,0,0,0.1)",
      display: "flex",
      width: "100%",
      position: "relative",
      "--cor-da-fonte": tema_1.colors.blue1,
      "--cor-da-borda": tema_1.colors.gray4,
      "--raio-da-borda": "4px",
      alignItems: "center",
      borderWidth: 1,
      borderColor: "var(--cor-da-borda)",
      borderStyle: "solid",
      borderRadius: "var(--raio-da-borda)",
      "&:focus-within": {
        "--cor-da-fonte": tema_1.colors.blue1,
        "--cor-da-borda": tema_1.colors.blue1
      },
      "&.com-erro": {
        "--cor-da-fonte": tema_1.colors.negativo,
        "--cor-da-borda": tema_1.colors.negativo,
        mb: 1
      },
      "&.desativado": {
        "--cor-da-fonte": tema_1.colors.gray5,
        "--cor-da-borda": tema_1.colors.gray5
      },
      "& .icone-de-status": {
        mr: 2
      },
      ".PhoneInputCountrySelect:focus + .PhoneInputCountryIcon + .PhoneInputCountrySelectArrow": {
        color: "var(--cor-da-fonte)"
      },
      ".PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border": {
        "boxShadow": "0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--cor-da-fonte),\n          inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--cor-da-fonte)"
      },
      ".PhoneInputCountrySelect:focus + .PhoneInputCountryIcon .PhoneInputInternationalIconGlobe": {
        color: "var(--cor-da-fonte)"
      },
      ".PhoneInput": {
        width: "100%",
        display: "flex",
        alignItems: "center",
        "&Country": {
          position: "relative",
          alignSelf: "stretch",
          display: "flex",
          alignItems: "center",
          padding: "10px",
          "&Select": {
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            zIndex: 1,
            border: 0,
            opacity: 0,
            cursor: "pointer",
            position: "absolute",
            "disabled": {
              cursor: "default"
            },
            "&Arrow": {
              display: "block",
              content: '" "',
              width: "var(--PhoneInputCountrySelectArrow-width)",
              height: "var(--PhoneInputCountrySelectArrow-width)",
              marginLeft: "var(--PhoneInputCountrySelectArrow-marginLeft)",
              borderStyle: "solid",
              borderColor: "var(--PhoneInputCountrySelectArrow-color)",
              borderTopWidth: 0,
              borderBottomWidth: "var(--PhoneInputCountrySelectArrow-borderWidth)",
              borderLeftWidth: 0,
              borderRightWidth: "var(--PhoneInputCountrySelectArrow-borderWidth)",
              transform: "var(--PhoneInputCountrySelectArrow-transform)",
              opacity: "var(--PhoneInputCountrySelectArrow-opacity)"
            }
          },
          "&Icon": {
            width: "calc(var(--PhoneInputCountryFlag-height) * var(--PhoneInputCountryFlag-aspectRatio))",
            height: "var(--PhoneInputCountryFlag-height)",
            "&--square": {
              width: "var(--PhoneInputCountryFlag-height)"
            },
            "&--border": {
              backgroundColor: "var(--PhoneInputCountryFlag-backgroundColor--loading)",
              boxShadow: "0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor),\n                  inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor)"
            },
            "&Img": {
              display: "block",
              width: "100%",
              height: "100%"
            }
          }
        },
        "&InternationalIcon": {
          "&Phone": {
            opacity: "var(--PhoneInputInternationalIconPhone-opacity)"
          },
          "&Globe": {
            opacity: "var(--PhoneInputInternationalIconGlobe-opacity)"
          }
        },
        input: {
          flex: 1,
          minWidth: 0,
          padding: 0,
          fontSize: 1,
          width: "100%",
          border: "none",
          borderRadius: "var(--raio-da-borda)",
          color: "var(--cor-da-fonte)",
          outline: "none",
          fontFamily: "heading",
          "&:-webkit-autofill, &:-webkit-autofill:focus, &:-webkit-autofill:hover": {
            boxShadow: "0 0 0px 1000px #FFF inset"
          },
          "::placeholder": {
            color: "var(--cor-da-fonte)"
          }
        }
      }
    }, sx)
  }, props));
};
exports.Container = Container;